import LocationSearch from './LocationSearch';

export default LocationSearch;
